module.exports = __webpack_public_path__ + "media/images/landing/second/photo24-6465fa5e07ca6d88ff443c2a72f93aec.jpg";